// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__So-bH","buttons":"Footer_buttons__kSa0H"};